module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/brain.7ec7682c.svg";